import { NgModule, ErrorHandler, APP_INITIALIZER  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HomeModule } from './pages/home/home.module';
import { AppRoutingModule } from './pages/app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutComponent } from './pages/layout/layout.component';
import { JwtModule } from "@auth0/angular-jwt";
import { AppInterceptorService } from './core/interceptors/app-interceptor.service';
import { Page401Component } from './pages/error/page401/page401.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginatorLabels } from './shared/material/custompaginatorconfiguration';
import { ErrorHandlerService } from './core/interceptors/app-insight-error.handler';
import { MyMonitoringService } from './core/service/logging.service';
import { Page403Component } from './pages/error/page403/page403.component';
import { Page408Component } from './pages/error/page408/page408.component';
import { ConfigFactory, EnvconfigService } from './core/service/envconfig.service';
import { tokenGetter } from './utils/utils';
import { SharedModule } from './shared/shared.module';
import { MaterialModule } from './shared/material/material.module';
import { SpinnerInterceptorService } from './core/interceptors/spinner-interceptor.service';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RetroalimentacionComponent } from './pages/retroalimentacion/retroalimentacion.component';
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

@NgModule({ 
  declarations: [
        AppComponent,
        LayoutComponent,
        Page401Component,
        Page403Component,
        Page408Component,
        RetroalimentacionComponent
    ],
    bootstrap: [AppComponent], 
    imports: [
      BrowserModule,
      BrowserAnimationsModule,
      HomeModule,
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      NgxMaskDirective, // Reemplaza a NgxMaskModule.forRoot(...)
      NgxMaskPipe, // Agregado si usas pipes de máscara en templates 
      JwtModule.forRoot({
          config: {
              tokenGetter: tokenGetter,
          },
      }),
      NgxSpinnerModule],
    providers: [
      provideNgxMask(),
        {
            provide: APP_INITIALIZER,
            useFactory: ConfigFactory,
            deps: [EnvconfigService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AppInterceptorService,
            multi: true,
        },
        EnvconfigService,
        MyMonitoringService,
        { provide: ErrorHandler, useClass: ErrorHandlerService },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },
        //  { provide: HTTP_INTERCEPTORS, 
        //    useClass: SpinnerInterceptorService, 
        //    multi: true },
        { provide: MatPaginatorIntl, useClass: CustomPaginatorLabels },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
